import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Host,
  HostBinding,
  HostListener,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { GasClickOutsideDirective } from '../../../utils/click-outside-directive/gas-click-outside.directive';
import { GasContextGroup, GasContextMenu, GasMenySize } from '../gas-menu.interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'gas-context-menu',
  templateUrl: './gas-context-menu.component.html',
  styleUrls: ['./gas-context-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    GasClickOutsideDirective,
  ],
})
export class GasContextMenuComponent {
  @Output('onMenuClicked')
  public onMenuClicked$ = new EventEmitter<GasContextMenu>();

  /** элемент вложенного меню */
  @ViewChild('subMenuItem', {static: false})
  public subMenuRef: ElementRef;

  /** навешиваем класс с размером меню */
  @HostBinding('class._large')
  public get largeSize(): boolean {
    return this.size === 'large';
  }
  @HostBinding('class._small')
  public get smallSize(): boolean {
    return this.size === 'small';
  }

  /** пункты меню */
  public gasContextMenu: GasContextGroup[] = [];

  /** Размер элемента меню */
  public size: GasMenySize | string = 'large';

  /** вложенное меню отображаемое на экране */
  public subMenu: GasContextMenu[];

  public closeContextMenuSubject$ = new Subject<boolean>();

  constructor(
    private renderer: Renderer2,
    public el: ElementRef,
    @Host() private gasClickOutsideDirective: GasClickOutsideDirective,
  ) {
    this.gasClickOutsideDirective.handleClick$
      .pipe(
        filter(click => !!click),
        untilDestroyed(this),
      ).subscribe(() => {
        this.closeContextMenuSubject$.next(true);
        this.subMenu = [];
      });
  }

  /** скрываем вложенное меню по потере фокуса */
  @HostListener('mouseleave', [])
  public hideContextMenu(): void {
    this.subMenu = [];
  }

  /**
   * отображаем вложенное меню по наведению на пункт меню
   */
  public showContextMenu(
    index: number,
    contextItem: GasContextGroup,
    link: GasContextMenu,
    menuItem: HTMLElement,
    groupMenu: HTMLElement,
  ): void {
    if (link.childs) {
      const offsetTop = this.calculatedOffsetTop(index + 1, contextItem, menuItem, groupMenu);
      this.subMenu = link.childs;
      this.renderer.setStyle(this.subMenuRef.nativeElement, 'top', offsetTop);
    } else {
      this.subMenu = [];
    }
  }

  /** Эмиттим выбранный пункт меню */
  public emitSelectedLink(link: GasContextMenu): void {
    if (link.callback) {
      link.callback();
    }

    this.onMenuClicked$.emit(link);
  }

  public contextItemClicked(item: GasContextMenu): void {
    if (item.disabled && !item.disabled()) {
      this.emitSelectedLink(item);
    } else {
      this.emitSelectedLink(item);
    }
  }

  /**
   * Рассчитываем координаты для top. Если это пункт из группы меню, к отступу прибавляем произведение высоты пункта меню и его
   * индекса увеличенного на 1 (если индекс = 0, то потеряем всю высоту). Если меню не из группы - просто возвращает отступ
   */
  private calculatedOffsetTop(index: number, contextItem: GasContextGroup, menuItem: HTMLElement, groupMenu: HTMLElement): string {
    const offset = contextItem.title ?
      groupMenu.offsetTop + menuItem.clientHeight * index :
      groupMenu.offsetTop;

    return `${offset}px`;
  }
}
